import { LayoutRectangle } from 'react-native';
import { Game, ImageType } from '../../state/shared/games.types';
import { GAME_IMAGE_SIZES } from '../Games/Game/Game.content';

export const getItemsPerRow = (
  layout: LayoutRectangle,
  imageType: ImageType,
  paddingHorizontal: number,
  gap: number,
) => {
  if (!layout.width) {
    return 0;
  }

  const availableSpace = layout.width - paddingHorizontal * 2;
  const itemWidth = GAME_IMAGE_SIZES[imageType].width;
  const itemsPerRow = Math.floor(
    availableSpace / GAME_IMAGE_SIZES[imageType].width,
  );
  const itemsSpace = itemsPerRow * itemWidth;

  return itemsSpace + (itemsPerRow - 1) * gap > availableSpace
    ? itemsPerRow - 1
    : itemsPerRow;
};

export const groupByRows = (
  results: Array<Game['id']>,
  itemsPerRow: number,
) => {
  if (itemsPerRow === 0) {
    return [];
  }

  const groupedResults: Array<typeof results> = [];

  for (let i = 0; i < results.length; i += itemsPerRow) {
    groupedResults.push(results.slice(i, i + itemsPerRow));
  }

  return groupedResults;
};
